import createCrudModule from '@/utils/createCrudModule'

export default createCrudModule({
  resource: 'businessContactTopics',
  urlRoot: '/business_contact_topics'
})
